import React, { useState, useEffect } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import Layout from './Layout';

const ToggleSwitch = ({ checked = false, disabled = false, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleToggle = () => {
    if (disabled) return;
    const newValue = !isChecked;
    setIsChecked(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <label className={`relative inline-block w-11 h-6 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
      <input
        type="checkbox"
        className="sr-only"
        checked={isChecked}
        onChange={handleToggle}
        disabled={disabled}
      />
      <div
        className={`block w-full h-full rounded-full transition-colors duration-300 ${
          isChecked ? 'bg-blue-500' : 'bg-gray-300'
        }`}
      ></div>
      <div
        className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
          isChecked ? 'translate-x-5' : 'translate-x-0'
        }`}
      ></div>
    </label>
  );
};

const PasswordInput = ({ placeholder, className = '' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        type={visible ? 'text' : 'password'}
        className={`w-full mt-1 px-3 py-2 pr-10 border border-gray-300 rounded-md ${className}`}
        placeholder={placeholder}
      />
      {visible ? (
        <EyeOff
          className="absolute right-3 top-3 w-5 h-5 text-gray-400 cursor-pointer"
          onClick={() => setVisible(false)}
        />
      ) : (
        <Eye
          className="absolute right-3 top-3 w-5 h-5 text-gray-400 cursor-pointer"
          onClick={() => setVisible(true)}
        />
      )}
    </div>
  );
};

const Settings = () => {
  return (
     <div className="min-h-screen ">
      <div className="mb-6 md:mb-8">
  <h1 className="text-xl md:text-2xl font-semibold text-gray-800">Platform Settings</h1>
  <p className="text-gray-600 mt-2">
    Manage system preferences, integrations, and account settings.
  </p>
</div>

<div className="space-y-6">
      {/* Pricing Settings */}
    {/* <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
  <h3 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
    <img src="/images/SVG (1).svg" alt="Dollar Icon" className="w-5 h-5" />
    Pricing Settings
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
    {["Assessment Fee", "Consultation Fee", "Subscription Price"].map((label, idx) => (
      <div key={idx} className=" ">
        <label className="text-xs text-gray-500">{label}</label>
        <div className="relative mt-1">
          <span className="absolute left-3 top-2.5 text-gray-400">$</span>
          <input
            type="number"
            className="w-full pl-7 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            placeholder={
              label === 'Assessment Fee' ? '299' :
              label === 'Consultation Fee' ? '999' : '129'
            }
          />
        </div>
      </div>
    ))}
  </div>
</div> */}


      {/* Stripe Integration */}
 <div className="bg-white rounded-xl shadow-sm border border-gray-200 px-6 p-6">
  <h3 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
    <img src="/images/SVG (1).svg" alt="Dollar Icon" className="w-5 h-5" />
    Stripe / Payment Integration
  </h3>

  <div className="space-y-4">
    <div>
      <label className="text-xs text-gray-500">Stripe Public Key</label>
      <input
        type="text"
        className="w-full mt-1 px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
        placeholder="pk_test_..."
      />
    </div>

    {["Stripe Secret Key", "Webhook Secret"].map((label, idx) => (
      <div key={idx}>
        <label className="text-xs text-gray-500">{label}</label>
        <PasswordInput
          placeholder="********"
          className="w-full mt-1 px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
        />
      </div>
    ))}

    <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md w-fit">
      Test Connection
    </button>
  </div>
</div>

{/* <div className="bg-white border border-gray-200 rounded-xl pt-6 px-6 pb-6 shadow-sm">
  <h3 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
    <img src="/images/SVG (2).svg" alt="Calendar Icon" className="w-5 h-5" />
    Calendar & Session Defaults
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
    {/* Doctor Hours From */}
    {/* <div>
      <label className="text-xs text-gray-500 block">Doctor Hours (From)</label>
      <input
        type="time"
        defaultValue="08:00"
        className="w-full mt-1 px-3 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      /> */}

      {/* Psychiatrist Session Length */}
      {/* <div className="mt-4">
        <label className="text-xs text-gray-500 block">Psychiatrist Session Length</label>
        <div className="relative">
          <select
            defaultValue="30"
            className="appearance-none w-full mt-1 px-3 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="15">15 mins</option>
            <option value="30">30 mins</option>
            <option value="45">45 mins</option>
            <option value="60">60 mins</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
            <svg className="w-4 h-4 text-gray-900" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>
    </div> */}

    {/* Doctor Hours To */}
    {/* <div>
      <label className="text-xs text-gray-500 block">Doctor Hours (To)</label>
      <input
        type="time"
        defaultValue="14:00"
        className="w-full mt-1 px-3 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      />
    </div> */}

    {/* Buffer Time + Nurse Session */}
    {/* <div>
      <label className="text-xs text-gray-500 block">Session Buffer Time (minutes)</label>
      <input
        type="number"
        defaultValue="5"
        className="w-full mt-1 px-3 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      />

      <div className="mt-4">
        <label className="text-xs text-gray-500 block">Nurse Session Length</label>
        <div className="relative">
          <select
            defaultValue="15"
            className="appearance-none w-full mt-1 px-3 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="15">15 mins</option>
            <option value="30">30 mins</option>
            <option value="45">45 mins</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
            <svg className="w-4 h-4 text-gray-900" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div> */}
{/* </div> */} 


      {/* Notification Settings */}
   <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
  <h3 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
    <img src="/images/SVG (3).svg" alt="Notification Icon" className="w-5 h-5" />
    Notification Settings
  </h3>

  <div className="space-y-4">
    {[
      {
        label: "Enable Email Reminders",
        desc: "Send automated email notifications to patients",
        checked: true,
      },
      {
        label: "Enable SMS Reminders",
        desc: "Send SMS notifications for important updates",
        checked: false,
      },
    ].map((item, i) => (
      <div key={i} className="flex items-center justify-between">
        <div className="max-w-[80%]">
          <p className="font-medium text-gray-800">{item.label}</p>
          <p className="text-sm text-gray-500">{item.desc}</p>
        </div>

        <ToggleSwitch checked={item.checked} />
      </div>
    ))}
  </div>
</div>


      {/* Security Settings */}
  <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
  <h3 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
    <img src="/images/SVG (4).svg" alt="Security Icon" className="w-5 h-5" />
    Security Settings
  </h3>

  <div className="space-y-5">
    {/* Enable 2FA */}
    <div className="flex items-center justify-between">
      <div className="max-w-[80%]">
        <p className="font-medium text-gray-800">Enable 2FA</p>
        <p className="text-sm text-gray-500">Require two-factor authentication for all users</p>
      </div>
      <ToggleSwitch checked />
    </div>

    {/* Session Timeout */}
    <div>
      <label className="text-sm font-medium text-gray-600">Session Timeout (minutes)</label>
      <input
        type="number"
        defaultValue="30"
        className="w-full mt-1 px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
      />
    </div>
  </div>
</div>


      {/* System Controls */}
   {/* <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
  <h3 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
    <img src="/images/SVG.svg" alt="System Icon" className="w-5 h-5" />
    System Controls
  </h3>

  {/* Maintenance Toggle */}
  {/* <div className="flex items-center justify-between mb-4">
    <div className="max-w-[80%]">
      <p className="font-medium text-gray-800">Enable Maintenance Mode</p>
      <p className="text-sm text-gray-500">Temporarily disable platform access</p>
    </div>
    <ToggleSwitch />
  </div> */}

  {/* System Version */}
  {/* <p className="text-xs text-gray-400 mb-4">Current Version: v1.0.3 (June 2025)</p> */}

  {/* Reset Button */}
  {/* <button className="text-blue-600 border border-blue-500 px-4 py-2 text-sm rounded-md hover:bg-blue-50 transition w-fit">
    Reset to Defaults
  </button> */}
{/* </div>  */}
    </div>  {/* Add other settings blocks here similarly */}

      {/* Footer Buttons */}
      <div className="flex justify-between pt-6">
        <button className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100">Cancel</button>
        <button className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">Save Changes</button>
      </div>
</div>
  );
};

export default Settings;